/**
 * DensityPicker — the user's own density, beside Theme in the user menu.
 *
 * "Default" follows the app-wide density an admin sets in Admin → Appearance
 * (shown in its tooltip); Comfortable or Compact overrides it for this user in
 * this browser. See utils/densityPreference.js.
 */
import { useContext } from "react";
import { Segmented } from "antd";

import { AppContext } from "../AppContextProvider";

const label = (density) => (density === "compact" ? "Compact" : "Comfortable");

const DensityPicker = () => {
  const { densityPreference, setDensityPreference, uiSettings } =
    useContext(AppContext);
  const appDefault = uiSettings?.density || "comfortable";
  return (
    // Keep clicks on the control from closing the menu it sits in.
    <div
      style={{ display: "flex", alignItems: "center", gap: 8, cursor: "default" }}
      onClick={(e) => e.stopPropagation()}
    >
      <span>Density</span>
      <Segmented
        size="small"
        value={densityPreference || "default"}
        onChange={setDensityPreference}
        options={[
          {
            value: "default",
            label: "Default",
            title: `The app's default: ${label(appDefault)}`,
          },
          { value: "comfortable", label: "Comfortable" },
          { value: "compact", label: "Compact" },
        ]}
      />
    </div>
  );
};

export default DensityPicker;
